import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { authHttpClient } from 'services/httpClient';
import IForgotPasswordRequestBody from 'services/httpClient/requests/auth/IForgotPasswordRequestBody';
import IForgotPasswordResponse from 'services/httpClient/responses/auth/IForgotPasswordResponse';

import { authActions } from '../index';
import { IForgotPasswordRequestAction } from '../reducers/forgotPassword/request';

function* forgotPassword(action: PayloadAction<IForgotPasswordRequestAction>) {
  try {
    const body: IForgotPasswordRequestBody = {
      email: action.payload.data.email,
      redirect_url: '/forgotpassword',
    };

    const {
      data: { success },
    }: AxiosResponse<IForgotPasswordResponse> = yield call(
      authHttpClient.post,
      'auth/password',
      body,
    );

    if (success) {
      yield put(
        authActions.forgotPasswordSuccess({
          email: action.payload.data.email,
        }),
      );
    } else {
      yield put(
        authActions.forgotPasswordSuccess({
          email: '',
        }),
      );
    }
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(authActions.forgotPasswordFailure());
  }
}

export default forgotPassword;
